import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

function formatErr(d) {
  if (d == null) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join(" ");
  return d.msg || String(d);
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="nx-container py-16 grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl">
      <div>
        <span className="mono text-[11px] text-slate-500">AUTH/01</span>
        <h1 className="text-5xl font-black tracking-tighter mt-2">Sign in.</h1>
        <p className="mt-4 text-slate-600 max-w-sm">Access your dashboard, orders and saved suppliers.</p>
        <div className="mt-8 hidden md:block">
          <div className="mono text-[10px] text-slate-500 mb-2">DEMO/ACCESS</div>
          <p className="text-xs text-slate-500">admin@nexara.com / Admin@12345</p>
        </div>
      </div>
      <form onSubmit={submit} className="border border-slate-900 p-8 bg-white space-y-4">
        <div>
          <label className="mono text-[11px] block mb-1">EMAIL</label>
          <input type="email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="login-email" className="w-full border border-slate-900 px-3 py-2 outline-none focus:border-blue-700" />
        </div>
        <div>
          <label className="mono text-[11px] block mb-1">PASSWORD</label>
          <input type="password" required value={password} onChange={e => setPassword(e.target.value)} data-testid="login-password" className="w-full border border-slate-900 px-3 py-2 outline-none focus:border-blue-700" />
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit" className="w-full nx-btn-primary disabled:opacity-50">
          {loading ? "Signing in..." : "Sign In"}
        </button>
        <div className="flex items-center gap-3 my-3">
          <div className="flex-1 h-px bg-slate-200"></div>
          <span className="mono text-[10px] text-slate-500">OR</span>
          <div className="flex-1 h-px bg-slate-200"></div>
        </div>
        <button type="button" onClick={google} data-testid="google-login-btn" className="w-full border border-slate-900 px-6 py-3 font-bold flex items-center justify-center gap-2 hover:bg-slate-50" style={{transition:"background-color 0.2s ease"}}>
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          Continue with Google
        </button>
        <p className="text-sm text-center text-slate-600 pt-2">
          Don't have an account? <Link to="/register" data-testid="go-register" className="text-blue-700 font-bold">Sign up</Link>
        </p>
      </form>
    </div>
  );
}
